import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";
import { useCurrentTrip } from "@/hooks";
import dayjs from "dayjs";

type Promotion = {
  id: number;
  tid: number;
  promotion_id: number;
  category: string;
  item: string;
  value: number;
  comment: null | string;
  currency: string;
  code: string;
};
type Discount = {
  id: number;
  invoice_id: number;
  amount: number;
  item: string;
  comments: string;
  trip_id: number;
  promotion_id: number;
};
type Result = {
  success: boolean;
  error: null;
  data: {
    promotions: Array<Promotion>;
    discounts: Array<Discount>;
  };
};
type QueryError = {};

const useTravellerTripPromotionsQuery = (
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;
  const url = `${ENDPOINT}/traveller/trip-id/${tid}`;
  const { fetchWithAuth } = useFetchWithAuth();
  const cacheKey = [url];

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!tid) throw new Error();
      const res = await fetchWithAuth<Result>(url);

      return res;
    },
    {
      enabled: !!tid,
      ...options,
    }
  );
};
export default useTravellerTripPromotionsQuery;
